//REGISTER
export const POST_LOGIN_TOKEN = "/login"
export const LOG_OUT = "/logout"
export const RESET_PASSWORD = '/account-reset'
export const RESET_CONFIRM = '/account-confirm'
export const VALIDA_TOKEN = '/account-valida-token'

//HOME
export const GET_DATA_HOME = '/cms/home'
//uSERS
export const USERS_RESOURCE = '/users'
//Rols users
export const ROLS_RESOURCE = '/transport-office/rols'
//clients
export const CLIENTS_RESOURCE = '/transport-office/clients'
export const CLIENTS_COMPANY_RESOURCE ='/cms/companies'
// plans
export const PLANS_RESOURCE = '/cms/plans'
export const PLANS_ACTIVATE = '/cms/plan-action'
//PAYMETS
export const PAYMENTS_METHODS_RESOURCE = '/transport-office/payments-methods'
export const PAYMENTS_RESOURCE = '/cms/payments'
//catalogos
export const GET_PREFIXES = '/catalogs-cms/prefixes'
export const GET_MODULES = '/catalogs-cms/models'
export const GET_PAYMENTS_PERIODS = '/catalogs-cms/payment-periods'
export const GET_STATUSES = '/catalogs-cms/statuses'
export const GET_TYPES = '/catalogs-cms/types'
export const MODELS_TRUCK_TRAILER_RESOURCE = '/catalogs-cms/models-trucks-trailer'
export const FABRICANTS_RESOURCE = '/catalogs-cms/fabricants'
export const GET_SCHEDULS = '/catalogs-cms/scheduls'
export const GET_PERMISSIONS = '/catalogs-cms/permissions'
//TRAILER_TRUCKS_RESOURCE
export const TRAILER_TRUCKS_RESOURCE = '/transport-office/trucks-trailer'
//Load
export const LOADS_RESOURCE  = '/transport-office/loads'
export const CHANGE_STATUS_LOAD = '/transport-office/change-status-load'
export const GET_IA_LOADS = '/transport-office/ia-load'
export const LOADS_AI_SAVE = '/transport-office/ia-load-save'
//SETTLEMENTS
export const SETTLEMENTS_RESOURCE = '/transport-office/settlements'
//suppliers
export const SUPPLIERS_RESOURCE = '/maintenance/suppliers'
// Services Orders
export const SERVICES_ORDER_RESOURCE = '/maintenance/service-orders'
export const CHANGE_STATUS_SERVICE_ORDER = '/maintenance/service-orders-status'
export const PREDICT_IA_SERVICES = '/maintenance/predict-service'
export const SERVICE_ORDER_AI_SAVE = '/maintenance/predict-service-save'
export const CHAT_AI  = '/ai/chat'
// Services Request
export const SERVICER_REQUEST_RESOURCE = '/transport-office/services-request'
//EVIDENCES
export const EVIDENCES_RESOURCE = '/transport-office/evidences'
// Catalogs mantenice
export const GET_SUPPLIER_TYPE = '/mantenience-catalogs/supplier-types'
export const GET_SUPPLIER_COMPANIES = '/mantenience-catalogs/supplier-companies'
export const GET_PAYMENTS_METHOD = 'catalogs-cms/payment-methods'
//export
export const GET_NEW_PLAN = '/transport-office/subscriptions-upgrade'
//REPORTS
export const REPORT_RESOURCE = '/maintenance/reports'
//CONFIGURATION ALERTS
export const CONFIGURATIONS_ALERTS_RESOURCE = '/transport-office/configurations-notifications'
//IAeLEMENTS
export const IA_ELEMENTS_RESOURCE = '/ai/elements'

export const GET_INTERESES = '/catalogos-registro/intereses'
export const GET_ESPECIALIDADES = '/catalogos-registro/especialidades'
export const GET_CUIDADOS = '/catalogos-registro/cuidados'
export const GET_ENTIDADES = '/catalogos-registro/entidades'
export const GET_HABILIDADES = '/catalogos-registro/habilidades'
export const GET_OFERTA_SERVICIOS = '/catalogos-registro/oferta-servicios'
export const GET_TIEMPOS= '/catalogos-registro/turnos-tiempos'

export const UP_TEMP_FILE = '/temp-files'




